/**
 * @module MfcNewsFeed
 * Imported from misc.mfcJS/MfcNewsFeed/MfcNewsFeed.js on 4/21/21
 * Added export default to end of file; update _apiUrl to work w/app.mfc
 * Update equality checks (from == to === and != to !==)
 */

/* eslint-disable @typescript-eslint/no-this-alias */
function MfcNewsFeed(searchKey, searchString) {
    // const _apiUrl = (MfcClientRes && MfcClientRes.apiUrl) || '/api/'
    const _options = {}
    const _apiUrl =
        typeof _options.apiUrl === 'string' && _options.apiUrl
            ? _options.apiUrl
            : typeof MfcClientRes === 'function' ||
              // eslint-disable-next-line @typescript-eslint/no-deprecated
              '//api-edge.' + document.domain.replace(/.*?(\w+\.\w+)$/, '$1')

    // changed 1/24/23 so we directly "all_models" instead of "subscriptions_friends" for parity with www
    this.view_selection = 'all_models'
    this.offset = 0
    this.size = 50
    this.news = []
    this.users = {}
    // adding default keys (these are undefined on instantiation) for type support
    this.search_key = searchKey || undefined
    this.search_string = searchString || undefined
    this.online_only = undefined

    this.optionsMask = {
        FCNEWSOPT_IN_CHAN: 1,
        FCNEWSOPT_IN_PM: 2,
        FCNEWSOPT_ADDFRIENDS_OFF: 4,
        FCNEWSOPT_IN_CHAN_NOPVT: 8,
        FCNEWSOPT_IN_CHAN_NOGRP: 16,
    }

    this.selection_types = {
        subscriptions_friends: 'Following + Friends',
        subscriptions: 'Following',
        all_models: 'All Models News',
        all_news: 'All Models & Members',
        myfreecams_news: 'MyFreeCams News',
        my_news: 'My Posts',
        recent_models: 'Models with News in past 24 hours',
    }

    this.createRequestObject = function () {
        let XHR
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        if (window.navigator.appName.indexOf('Internet Explorer') > -1) {
            // eslint-disable-next-line no-undef
            XHR = new ActiveXObject('Microsoft.XMLHTTP')
        } else {
            XHR = new XMLHttpRequest()
            XHR.withCredentials = true
        }

        return XHR
    }

    this.token = null

    const tokenReq = new XMLHttpRequest()
    /**
     * Request token
     */
    this.getToken = function () {
        const self = this
        tokenReq.open('GET', _apiUrl + '/token')
        tokenReq.withCredentials = true
        tokenReq.onreadystatechange = function () {
            self.getToken_callback()
        }
        tokenReq.send()
    }
    /**
     * token request callback
     * @returns Token
     */
    this.getToken_callback = function () {
        if (tokenReq.readyState !== 4) {
            return
        }

        let res = {}
        try {
            res = JSON.parse(tokenReq.responseText)
        } catch (e) {
            console.log(e)
        }

        if (res && res.result) {
            this.token = res.result.token
        }
    }
    this.getToken()

    /**
     * get news information
     * @param { callback } options
     */
    this.getInfo = function (options) {
        options = options || {}

        // const self = this
        const req = this.createRequestObject()

        req.open('GET', _apiUrl + '/newsfeed/info')
        req.onreadystatechange = function () {
            if (req.readyState !== 4) {
                return
            }
            //console.log( req.responseText );
            const res = JSON.parse(req.responseText)
            if (res && res.result && options.callback) {
                options.callback(res.result)
            }
        }
        req.send(null)
    }

    /**
     * Get News from API
     * @param { update_only, update_from, callback } options
     */
    this.getNews = function (options) {
        options = options || {}

        const self = this
        const req = this.createRequestObject()

        const args = {
            view_selection: this.search_string ? 'search' : this.view_selection,
        }

        if (options.update_only && self.maxId) {
            options.update_from = self.maxId
        }
        if (this.offset) {
            args.offset = this.offset
        }
        if (this.size) {
            args.size = this.size
        }
        if (this.search_string) {
            args.search_string = this.search_string
        }
        if (this.search_key) {
            args.search_key = this.search_key
        }
        if (this.online_only) {
            args.online_only = this.online_only
        }

        for (const k in options) {
            if (typeof options[k] !== 'function') {
                args[k] = options[k]
            }
        }

        req.open(
            'GET',
            _apiUrl + '/newsfeed?' + new URLSearchParams(args).toString(),
        )
        req.onreadystatechange = function () {
            if (req.readyState !== 4) {
                return
            }
            //console.log( 'getNews callback', req.responseText );
            const res = JSON.parse(req.responseText)
            if (res && res.result) {
                // if the view mode has changed, reset the news cache
                if (self.current_view_selection !== res.result.view_selection) {
                    //console.log(' PURGE ',  self.current_view_selection,' != ',res.result.view_selection );
                    self.news = []
                    self.maxId = 0
                }

                if (res.result.news && res.result.news.length > 0) {
                    //console.log(' NEWS ',  res.result.news );
                    if (!self.news[0]) self.news = res.result.news
                    else if (res.result.news[0]['id'] > self.news[0]['id'])
                        self.news = res.result.news.concat(self.news)
                    else self.news = self.news.concat(res.result.news)

                    self.maxId = self.news[0]['id']
                }

                if (res.result.users) {
                    //console.log(' USERS ',  res.result.users );
                    for (const user_id in res.result.users)
                        self.users[user_id] = res.result.users[user_id]
                }

                self.current_view_selection = res.result.view_selection

                res.result.news = self.news
                res.result.users = self.users

                if (options.callback) {
                    options.callback(res.result)
                }
            }
        }
        req.send(null)
    }

    /**
     * Change current news selection
     * @param { selection, view_selection, callback } options
     */
    this.changeViewSelection = function (options) {
        this.news = []
        this.offset = 0
        this.view_selection = options.selection || this.view_selection

        if (typeof options.online_only !== 'undefined') {
            this.online_only = options.online_only
        }

        if (options.callback) {
            options.callback(options)
        }
    }

    /**
     * Post news from account
     * @param {*} data
     * @param {*} options
     */
    this.postNews = function (data, options) {
        options = options || {}

        data.token = this.token

        const req = this.createRequestObject()
        req.open('POST', _apiUrl + '/newsfeed/news')
        req.withCredentials = true
        req.onreadystatechange = function () {
            if (req.readyState !== 4) {
                return
            }
            const res = JSON.parse(req.responseText)

            if (options.callback) {
                options.callback(res.result)
            }
        }
        req.setRequestHeader(
            'Content-type',
            'application/x-www-form-urlencoded',
        )
        req.send(new URLSearchParams(data).toString())
    }

    /**
     * Delete a news post
     * @param {*} options
     */
    this.deleteNews = function (options) {
        options = options || {}

        const data = {
            token: this.token,
            id: options.id,
        }

        const req = this.createRequestObject()
        req.open('DELETE', _apiUrl + '/newsfeed/news')
        req.withCredentials = true
        req.onreadystatechange = function () {
            if (req.readyState !== 4) {
                return
            }
            const res = JSON.parse(req.responseText)

            //console.log('deletenews callback', req.responseText );
            if (options.callback) {
                options.callback(res.result)
            }
        }
        req.setRequestHeader(
            'Content-type',
            'application/x-www-form-urlencoded',
        )
        req.send(new URLSearchParams(data).toString())
    }

    /**
     * update options
     * @param {*} options
     */
    this.putOption = function (options) {
        options = options || {}

        const data = {
            token: this.token,
            key: options.key,
            value: options.value,
        }

        const req = this.createRequestObject()
        req.open('PUT', _apiUrl + '/newsfeed/option')
        req.withCredentials = true
        req.onreadystatechange = function () {
            if (req.readyState !== 4) {
                return
            }
            const res = JSON.parse(req.responseText)

            //console.log( req.responseText );
            if (options.callback) {
                options.callback(res.result)
            }
        }
        req.setRequestHeader(
            'Content-type',
            'application/x-www-form-urlencoded',
        )
        req.send(new URLSearchParams(data).toString())
    }

    /**
     * delete an option
     * @param {*} options
     */
    this.deleteOption = function (options) {
        options = options || {}

        const data = {
            token: this.token,
            key: options.key,
            value: options.value,
        }

        const req = this.createRequestObject()
        req.open('DELETE', _apiUrl + '/newsfeed/option')
        req.withCredentials = true
        req.onreadystatechange = function () {
            if (req.readyState !== 4) {
                return
            }
            const res = JSON.parse(req.responseText)

            if (options.callback) {
                options.callback(res.result)
            }
        }
        req.setRequestHeader(
            'Content-type',
            'application/x-www-form-urlencoded',
        )
        req.send(new URLSearchParams(data).toString())
    }
}

export default MfcNewsFeed
